import { COMPONENT_NAME_PREFIX } from '../../constants';
var elementName = COMPONENT_NAME_PREFIX + "omnibar-help-button";
export var OMNIBAR_HELP_BUTTON_CONSTANTS = {
    elementName: elementName
};
